import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { DatePipe } from '@angular/common';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { LayoutRoutingModule } from './layout-routing.module';
import { VerifyPatientComponent } from './verify-patient/verify-patient.component';
import { UpdateRecordComponent } from './update-record/update-record.component';
import { CareTeamComponent } from './care-team/care-team.component';
import { InusrancesComponent } from './inusrances/inusrances.component';
import { SymptomsComponent } from './symptoms/symptoms.component';
import { LayoutComponent } from './layout/layout.component';
import { CovidFormComponent } from './covid-form/covid-form.component';
import { LayoutfooterComponent } from './layoutfooter/layoutfooter.component';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { ConsentformComponent } from './consentform/consentform.component';
import { NavbarComponent } from './layout/navbar/navbar.component';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FinancialFormComponent } from './financial-form/financial-form.component';
import { IntakemoduleModule } from './intakemodule/intakemodule.module';
import { SymptomsMaleComponent } from './symptoms-male/symptoms-male.component';
import { FollowupComponent } from './followup/followup.component';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { SymptomsquestionsComponent } from './symptoms/symptomsquestions/symptomsquestions.component';
//import { SignaturePadModule } from 'ngx-signaturepad';
import { TokenInterceptor } from '../services/guards/token-interceptor';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core'
import { MatDatepickerModule } from '@angular/material/datepicker';
import { VisitReasonComponent } from './visit-reason/visit-reason.component';
import { PaymentOverviewComponent } from './payment-overview/payment-overview.component';
import { PaymentComponent } from './payment/payment.component';
import { CommonModule } from '@angular/common';
@NgModule({
  declarations: [
    VerifyPatientComponent,
    LayoutComponent,
    UpdateRecordComponent,
    CareTeamComponent,
    InusrancesComponent,
    SymptomsComponent,
    CovidFormComponent,
    LayoutfooterComponent,
    ThankYouComponent,
    ConsentformComponent,
    NavbarComponent,
    FinancialFormComponent,
    SymptomsMaleComponent,
    FollowupComponent,
    SymptomsquestionsComponent,
    VisitReasonComponent,
    PaymentOverviewComponent,
    PaymentComponent,
  ],
  exports: [
    LayoutComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA], imports: [CommonModule,
    LayoutRoutingModule,
    BrowserModule,
    ReactiveFormsModule,
    ToastrModule.forRoot({
      positionClass: 'toast-top-full-width',
      preventDuplicates: true,
    }),
    NgxSpinnerModule,
    BrowserAnimationsModule,
    MatFormFieldModule,
    MatInputModule,
    MatInputModule,
    FormsModule,
    CarouselModule,
    MatAutocompleteModule,
    //SignaturePadModule,
    IntakemoduleModule,
    NgbModule,
    PdfViewerModule,
    MatDatepickerModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })],providers: [DatePipe,{ provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true }, provideHttpClient(withInterceptorsFromDi())]
})
export class LayoutModule { }
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
